module.exports = __webpack_public_path__ + "img/cardown.57a9cdc2.png";